<template>
    <sections>
        <section-text color="bg-zinc-100" padding="py-4 pb-3">
            <template v-slot:custom>
                <layout-search-bar-light
                    :searchQuery="searchQuery"
                    :makeSearch="makeSearch"
                    placeholder="Search west coast swing..."
                    :focus="true"
                ></layout-search-bar-light>
            </template>
        </section-text>
        <section-tiles
            v-if="!firstSearch"
            padding="pb-4"
            tileColor="bg-white hover:bg-white"
            :tiles="searchResults()"
        ></section-tiles>
    </sections>
</template>

<script setup>
const {firstSearch, searchQuery, searchResults} = storeToRefs(useStoreSearch());
const {makeSearch} = useStoreSearch();

const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Search | ' + $config.public.companyName,
    description: 'Find dancers, events and classes',
    index: false,
});
</script>
